<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Financial Reports</h4>
                    <ReportDownloader report-label="Accounting Roster"
                                      endpoint="Wraparound/Reports/ProgramReports/AccountingRoster"
                                      :parameter-schema="ParamsSubProgramMonthYear"
                                      report-description="Generates an Excel file listing all clients enrolled in the selected Wraparound program for a given month.  Used for monthly census invoicing." />
                    <ReportDownloader permission-requirement="Wraparound.FlexFunds"
                                      report-label="Flex Funds Expenditures"
                                      endpoint="Wraparound/Reports/ProgramReports/FlexFundsExpenditures"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Provides a list of flex funds expenditures in a target time frame, summed by both clients and staff." />
                    <ReportDownloader permission-requirement="Wraparound.FlexFunds"
                                      report-label="Flex Fund Accounting Report Recon"
                                      endpoint="Wraparound/Reports/ProgramReports/FlexFundReconCheck"
                                      :parameter-schema="ParamsFlexRecon"
                                      method="POST"
                                      report-description="Displays which transactions from Accounting's Transaction Report appear in OLIVER.  Green indicates match to OLIVER flex fund entry.  Orange indicates no match.  Yellow indicates no employee credit card account name on file for that transaction." />
                    <ReportDownloader report-label="Census Verification"
                                      report-description="*** DRAFT REPORT FOR TESTING ONLY- NOT ACCURATE *** Downloads a list of activity for the period indicated.  An identical report can be emailed to the program's distribution list for approval/rejection."
                                      endpoint="Core/CensusApprovals/CreateCensusApproval"
                                      :parameter-schema="ParamsSubProgramStartEndReportType" />
                    <ReportDownloader report-label="Census Financials"
                                      report-description="*** DRAFT REPORT FOR TESTING ONLY- NOT ACCURATE *** Generates Revenue/Expense transactions for all billable activity in the specified month and year."
                                      endpoint="Core/CensusApprovals/TransactionsReport"
                                      permission-requirement="Reports.CensusFinancials"
                                      :parameter-schema="ParamsSubProgramMonthYearInt" />
                </div>
                <div class="col-md-4">
                    <h4>Census Reports</h4>
                    <ReportDownloader report-label="Census Metrics"
                                      endpoint="Wraparound/Reports/ProgramReports/CensusMetrics"
                                      :parameter-schema="ParamsCensusMetrics"
                                      report-description="Generates an Excel file listing census metrics.  Data is split by territory (Riverside, Desert, and Combined) and by the time period selected." />
                    <ReportDownloader report-label="Supervisor Tracker"
                                      endpoint="Wraparound/Reports/ProgramReports/SupervisorTrackerReport"
                                      :parameter-schema="ParamsSupervisorTracker"
                                      report-description="Generates an Excel file for the Supervisor Tracker, with the ability to include selected datapoints." />
                    <ReportDownloader report-label="Intakes and Exits"
                                      endpoint="Wraparound/Reports/ProgramReports/GetIntakesAndExitsReport"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists all clients who who had an Intake or Discharge RECORDED in the specified time range.  Actual Intake or Exit date is not rellevent here- only the date in which is was recorded by a user.  The actual effective date of the intake or exit is included in the content of the report." />
                    <ReportDownloader report-label="Client History"
                                      endpoint="Wraparound/Reports/ProgramReports/ClientHistory"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-description="Lists data on clients enrolled in wraparound during the specified time period." />
                    <ReportDownloader report-label="Monthly Program Summary"
                                      endpoint="Wraparound/Reports/ProgramReports/MonthlyProgramSummary"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-description="Generates the DPSS Monthly Summary Report, to be submitted once monthly." />
                    <ReportDownloader report-label="Average Daily Caseloads"
                                      endpoint="Core/Reports/ProgramReports/AverageDailyCaseloads"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Provides a list of Average Daily Caseloads per employee in the given time range." />
                    <ReportDownloader report-label="Wrap Stat Youth Roster"
                                      endpoint="Wraparound/Reports/ProgramReports/WrapStatYouthRoster"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-description="Generates Report that can be used to update the youth roster in Wrap Stat" />

                </div>
                <div class="col-md-4">
                    <h4>Treatment Reports</h4>
                    <ReportDownloader report-label="Continuation of Services"
                                      endpoint="Wraparound/Reports/ProgramReports/ContinuationOfServicesReport"
                                      :parameter-schema="ParamsSubProgramMonthYear"
                                      report-description="Generates an Excel file showing all clients who have been receiving Wraparound services for more than 8 months.  Lists information on the DPSS Continuation of Services forms, showing which clients have the forms on file, and while ones need one." />
                    
                    <ReportDownloader report-label="Monthly Summary Statuses"
                                      endpoint="Wraparound/Reports/ProgramReports/MonthlySummaryReport"
                                      :parameter-schema="ParamsSubProgramMonthYearIncludeFiles"
                                      report-description="Provides a list of clients enrolled during the month and the status of their Monthly Summary" />
                </div>
                <div class="col-md-4">
                    <h4>Productivity Reports</h4>
                    <ReportDownloader permission-requirement="Wraparound.Employees.Documentation"
                                      report-label="Returned Documents"
                                      endpoint="Wraparound/Reports/ProgramReports/GetReturnedDocumentsReport"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="A list of all returned documents for a specific time period, to include comments made by reviewer." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity"
                                      report-label="Wrap Productivity"
                                      endpoint="Wraparound/Reports/ProgramReports/GetWrapProductivity"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Creates a list of metrics for Facilitator performance.  Includes timelines on activity within range specified." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-label="Client Schedule"
                                      endpoint="Wraparound/Reports/ProgramReports/GetNextWeeksSchedule"
                                      :parameter-schema="ParamsSubProgramTargetDateWeek"
                                      report-description="Generates a list showing scheduled appointments for clients during the week selected (Sunday-Saturday)." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-label="Service List"
                                      endpoint="Wraparound/Reports/ProgramReports/GetServiceList"
                                      :parameter-schema="ParamsServiceList"
                                      report-description="Lists all services provided by Wraparound Staff for a given time range." />
                    <ReportDownloader permission-requirement="Administrator"
                                      report-label="Mental Health Weekly Productivity History"
                                      endpoint="MentalHealth/Billing/Reports/WeeklyProductivityReport"
                                      :parameter-schema="ParamsStartEnd"
                                      report-description="Lists weekly Percent to Goal and Percent on Time for All Employees who write MH Notes." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-label="Provider MH Productivity"
                                      endpoint="MentalHealth/Billing/Reports/GetProviderHoursAndOnTime"
                                      :parameter-schema="ParamsStartEndLocationWrap"
                                      report-description="Provides a list of notes for each provider, with their completion date, due date, and whether or not the note was written on time.  Summary report split by assigned supervisor" />
                    
                    <ReportDownloader 
                                      report-label="POC Listing"
                                      endpoint="Wraparound/Reports/ProgramReports/POCListing"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists all clients enrolled furing target window, along with ALL of their POCs.  POCs are indicated as signed or not." />

                    <ReportDownloader permission-requirement="MentalHealth.Employees.Productivity"
                                      report-label="Last MH Services"
                                      endpoint="MentalHealth/Billing/Reports/LastMHServicesReport"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists all clients enrolled in the target time period and indicates the last documented mental health service as well as the last documented 530 ICCR." />

                </div>
                <div class="col-md-4">
                    <h4>Misc Reports</h4>
                    <ReportDownloader report-label="Child Birthdays"
                                      endpoint="Core/Reports/ProgramReports/GetBirthdays"
                                      :parameter-schema="ParamsClientBirthdayOptions"
                                      report-description="Lists the birthdays of current children, with options to specify the level of privacy on the generated list." />
                    <ReportDownloader report-label="Discharge Outcomes By Employee"
                                      endpoint="Core/Reports/ProgramReports/DischargeOutcomesByEmployee"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      permission-requirement="Wraparound.Employees.Productivity"
                                      report-description="Provides a list that shows average length of stay by Caseload Assignment" />
                    <ReportDownloader report-label="Aftercare Log Data"
                                      endpoint="Wraparound/Reports/ProgramReports/AfterCareData"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      permission-requirement="Wraparound.Employees.Productivity"
                                      report-description="Lists all after care data in a table for the time period indicated." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-label="Case Weights"
                                      endpoint="Wraparound/Reports/ProgramReports/ClientCaseWeights"
                                      :parameter-schema="ParamsSubProgramTargetDate"
                                      report-description="Generates a list sof clients enrolled on the target date, with their calculated caseload weight size.  Factors that go into determining the weight are included." />
                    <ReportDownloader permission-requirement="Wraparound.Employees.Productivity.ServiceList"
                                      report-label="Last Document Per Client"
                                      endpoint="Wraparound/Reports/ProgramReports/ClientLastDocuments"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Generates a list of all clients enrolled during the timeframe, and lists each document type, and the most recent date of that document on file." />
                </div>
                <div class="col-md-4">
                    <h4>Outcomes Reports</h4>
                    <ReportDownloader report-label="Educational Outcomes"
                                      endpoint="Wraparound/Reports/ProgramReports/WrapEOMs"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Educational Outcomes Measure Reporting" />
                    <ReportDownloader report-label="SIR Summaries"
                                      endpoint="Core/Reports/ProgramReports/SIRSummary"
                                      :parameter-schema="ParamsSubProgramStartEnd"
                                      report-description="Lists all SIRs in time range." 
                                      permission-requirement="Reports.SIRSummary" />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../Core/UI/ReportDownloader.vue';
    export default {
        props: [],
        data: function () {
            return {
                ParamsFlexRecon: [
                    {
                        Label: "Transaction Report from Accounting:",
                        Name: "Report",
                        Type: "FileUpload",
                        Accept: ".xlsx,.xls",
                        Required: true
                    },
                ],
                ParamsSubProgramMonthYear: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "January",
                                value: 1
                            },
                            {
                                text: "February",
                                value: 2
                            },
                            {
                                text: "March",
                                value: 3
                            },
                            {
                                text: "April",
                                value: 4
                            },
                            {
                                text: "May",
                                value: 5
                            },
                            {
                                text: "June",
                                value: 6
                            },
                            {
                                text: "July",
                                value: 7
                            },
                            {
                                text: "August",
                                value: 8
                            },
                            {
                                text: "September",
                                value: 9
                            },
                            {
                                text: "October",
                                value: 10
                            },
                            {
                                text: "November",
                                value: 11
                            },
                            {
                                text: "December",
                                value: 12
                            },
                        ]
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "2020",
                                value: 2020
                            },
                            {
                                text: "2021",
                                value: 2021
                            },
                            {
                                text: "2022",
                                value: 2022
                            },
                            {
                                text: "2023",
                                value: 2023
                            },
                            {
                                text: "2024",
                                value: 2024
                            },
                            {
                                text: "2025",
                                value: 2025
                            },
                            {
                                text: "2026",
                                value: 2026
                            }
                        ]
                    }
                ],
                ParamsSubProgramMonthYearIncludeFiles: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Month:",
                        Name: "Month",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "January",
                                value: 1
                            },
                            {
                                text: "February",
                                value: 2
                            },
                            {
                                text: "March",
                                value: 3
                            },
                            {
                                text: "April",
                                value: 4
                            },
                            {
                                text: "May",
                                value: 5
                            },
                            {
                                text: "June",
                                value: 6
                            },
                            {
                                text: "July",
                                value: 7
                            },
                            {
                                text: "August",
                                value: 8
                            },
                            {
                                text: "September",
                                value: 9
                            },
                            {
                                text: "October",
                                value: 10
                            },
                            {
                                text: "November",
                                value: 11
                            },
                            {
                                text: "December",
                                value: 12
                            },
                        ]
                    },
                    {
                        Label: "Year:",
                        Name: "Year",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "2020",
                                value: 2020
                            },
                            {
                                text: "2021",
                                value: 2021
                            },
                            {
                                text: "2022",
                                value: 2022
                            },
                            {
                                text: "2023",
                                value: 2023
                            },
                            {
                                text: "2024",
                                value: 2024
                            },
                            {
                                text: "2025",
                                value: 2025
                            },
                            {
                                text: "2026",
                                value: 2026
                            }
                        ]
                    },
                    {
                        Label: "Report Type:",
                        Name: "IncludeFiles",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "Summary Report",
                                value: false
                            },
                            {
                                text: "PDF Files",
                                value: true
                            },
                        ]
                    },
                ],
                ParamsStartEndLocationWrap: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Location:",
                        Name: "Location",
                        Type: "HiddenConstant",
                        Value: "Wraparound",
                        DisplayValue: "Wraparound"
                    }
                ],
                ParamsClientBirthdayOptions: [
                    {
                        Label: "Program:",
                        Name: "SubProgramId",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Columns to Show:",
                        Type: "CheckBoxBool",
                        Required: false,
                        Options: [
                            {
                                text: "Include Last Name",
                                name: "IncludeLastName",
                                checked: true
                            },
                            {
                                text: "Include Date Of Birth",
                                name: "IncludeDateOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Year Of Birth",
                                name: "IncludeYearOfBirth",
                                checked: true
                            },
                            {
                                text: "Include Month",
                                name: "IncludeDayOfMonth",
                                checked: true
                            },
                            {
                                text: "Include Day",
                                name: "IncludeDay",
                                checked: true
                            },
                            {
                                text: "Include Age",
                                name: "IncludeAge",
                                checked: true
                            },
                            {
                                text: "Include Gender",
                                name: "IncludeGender",
                                checked: true
                            }
                        ]
                    }
                ],
                ParamsSupervisorTracker: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Data Points:",
                        Name: "pst-",
                        Type: "CheckBoxPrefixed",
                        Required: false,
                        Options: [
                            {
                                text: "Name",
                                nameSuffix: "name",
                                checked: true
                            },
                            {
                                text: "Age",
                                nameSuffix: "age",
                                checked: true
                            },
                            {
                                text: "DOB",
                                nameSuffix: "dob",
                                checked: true
                            },
                            {
                                text: "Referral Date",
                                nameSuffix: "referralDate",
                                checked: true
                            },
                            {
                                text: "First Contact Date",
                                nameSuffix: "initialContact",
                                checked: false
                            },
                            {
                                text: "First F2F",
                                nameSuffix: "initialF2F",
                                checked: true
                            },
                            {
                                text: "First CCP Date",
                                nameSuffix: "txPlanImp",
                                checked: false
                            },
                            {
                                text: "First Clinical Contact",
                                nameSuffix: "firstClinicalContact",
                                checked: false
                            },
                            {
                                text: "Discharge",
                                nameSuffix: "dischargeDate",
                                checked: true
                            },
                            {
                                text: "FTM Frequency",
                                nameSuffix: "frequencyFTM",
                                checked: true
                            },
                            {
                                text: "BHS Frequency",
                                nameSuffix: "frequencyBHS",
                                checked: true
                            },
                            {
                                text: "PP Frequency",
                                nameSuffix: "frequencyPP",
                                checked: true
                            },
                            {
                                text: "Clinician Frequency",
                                nameSuffix: "frequencyClin",
                                checked: true
                            },
                            {
                                text: "Facilitator",
                                nameSuffix: "facName",
                                checked: false
                            },
                            {
                                text: "BHS",
                                nameSuffix: "BHSName",
                                checked: false
                            },
                            {
                                text: "Parent Partner",
                                nameSuffix: "PPName",
                                checked: false
                            },
                            {
                                text: "Clinician",
                                nameSuffix: "clinicianName",
                                checked: false
                            },
                            {
                                text: "Phase",
                                nameSuffix: "phase",
                                checked: false
                            },
                            {
                                text: "Worker",
                                nameSuffix: "workerPrimary",
                                checked: false
                            },
                            {
                                text: "Primary Language",
                                nameSuffix: "languagePrimary",
                                checked: false
                            },
                            {
                                text: "Population",
                                nameSuffix: "population",
                                checked: true
                            },
                            {
                                text: "Acuity",
                                nameSuffix: "acuity",
                                checked: true
                            },
                            {
                                text: "Last POC",
                                nameSuffix: "POCDate",
                                checked: true
                            },
                            {
                                text: "Next POC Due",
                                nameSuffix: "POCNextDue",
                                checked: true
                            },
                            {
                                text: "Location",
                                nameSuffix: "location",
                                checked: true
                            },
                            {
                                text: "Placement Type",
                                nameSuffix: "placementType",
                                checked: true
                            },
                            {
                                text: "SSN",
                                nameSuffix: "lNum",
                                checked: false
                            },
                            {
                                text: "Contact Status",
                                nameSuffix: "contactStatus",
                                checked: false
                            },
                            {
                                text: "Last Services",
                                nameSuffix: "lastService",
                                checked: false
                            }
                        ]
                    },
                    {
                        Label: "Teams:",
                        Name: "pst-team-",
                        Type: "CheckBoxPrefixed",
                        Required: false,
                        Options: []
                    },
                    {
                        Label: "Client Status:",
                        Name: "pst-",
                        Type: "CheckBoxPrefixed",
                        Required: false,
                        Options: [
                            {
                                text: "Active Clients",
                                nameSuffix: "showActive",
                                checked: true
                            },
                            {
                                text: "Discharged Clients",
                                nameSuffix: "showDischarged",
                                checked: false
                            },
                        ]
                    }
                ],
                ParamsCensusMetrics: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Time Split:",
                        Name: "SplitBy",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "None",
                                value: "None"
                            },
                            {
                                text: "Week",
                                value: "Week"
                            },
                            {
                                text: "Month",
                                value: "Month"
                            },
                            {
                                text: "Year",
                                value: "Year"
                            }
                        ]
                    }
                ],
                ParamsSubProgramStartEnd: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramStartEndProgramType: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Service Type:",
                        Name: "ProgramType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "Wraparound",
                                value: "Wraparound"
                            },
                            {
                                text: "Mental Health",
                                value: "MentalHealth"
                            }
                        ]
                    },

                ],
                ParamsServiceList: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Service Type:",
                        Name: "ProgramType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "Wraparound",
                                value: "Wraparound"
                            },
                            {
                                text: "Mental Health",
                                value: "MentalHealth"
                            }
                        ]
                    },
                    {
                        Label: "Supervisor:",
                        Name: "SupervisorEmployeeID",
                        Type: "Select",
                        Required: false,
                        Options: [
                            {
                                text: "ALL",
                                value: null
                            },
                            {
                                text: "Adriana Ornelas",
                                value: "8F32445E-4E43-4231-528B-08D914C193C3"
                            },
                            {
                                text: "Ana Mirande",
                                value: "2832422A-89D1-4B01-5296-08D914C193C3"
                            },
                            {
                                text: "Anabel Godoy",
                                value: "95276B80-2E9F-4186-528F-08D914C193C3"
                            },
                            {
                                text: "Carmen King",
                                value: "EC008121-BAE4-4A18-52DE-08D914C193C3"
                            },
                            {
                                text: "Chelsea Rollins",
                                value: "634904A0-FA9B-41FC-52AC-08D914C193C3"
                            },
                            {
                                text: "Cheryl Beavers",
                                value: "013135A6-AD2E-4E08-52DC-08D914C193C3"
                            },
                            {
                                text: "Christine Munoz",
                                value: "77B3DD28-5AE9-43F7-52F7-08D914C193C3"
                            },
                            {
                                text: "Darius Trimble",
                                value: "ED16BEE3-3733-4693-529D-08D914C193C3"
                            },
                            {
                                text: "Elva Zamudio-Gonzalez",
                                value: "D6BA363C-1209-434F-531E-08D914C193C3"
                            },
                            {
                                text: "Erica Mendez",
                                value: "0A4FAE15-E4F7-4EF9-52DB-08D914C193C3"
                            },
                            {
                                text: "Gaby Quintero",
                                value: "3CC18248-ECA1-474F-5289-08D914C193C3"
                            },
                            {
                                text: "Jacqueline Brown",
                                value: "973AECC1-4FC0-4F6C-8B92-08D8EA339D01"
                            },
                            {
                                text: "Jennifer Lopez",
                                value: "BC0ED1E9-0E99-4EC9-52AD-08D914C193C3"
                            },
                            {
                                text: "Jessica Fincher",
                                value: "00E12B3B-A429-4941-52EA-08D914C193C3"
                            },
                            {
                                text: "Katie Angkiangco",
                                value: "A1FC746C-35A9-431D-527F-08D914C193C3"
                            },
                            {
                                text: "Matthew Boughton",
                                value: "9AE5D462-E8E5-4732-52A4-08D914C193C3"
                            },
                            {
                                text: "Monica Madueno",
                                value: "5D7224D1-A773-4FF1-5294-08D914C193C3"
                            },
                            {
                                text: "Rechelle West",
                                value: "8E2FDCF4-FDAE-4DAC-52B4-08D914C193C3"
                            },
                            {
                                text: "Rhonna Tan",
                                value: "5B04B111-621E-4BCE-6057-08D90BE56EC3"
                            },
                            {
                                text: "Sade Ogunleye",
                                value: "9E60AB18-149A-47EC-27AA-08D9B5DE1DE0"
                            },
                            {
                                text: "Vanessa Hernandez",
                                value: "F653CB26-9551-4052-5284-08D914C193C3"
                            }
                        ]
                    },

                ],
                ParamsStartEnd: [
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramTargetDateWeek: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Target Week:",
                        Name: "TargetDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramTargetDate: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Target Date:",
                        Name: "TargetDate",
                        Type: "Date",
                        Required: true
                    }
                ],
                ParamsSubProgramMonthYearInt: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Month (1-12):",
                        Name: "Month",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Year (4 digits):",
                        Name: "Year",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],
                ParamsSubProgramStartEndReportType: [
                    {
                        Label: "Program:",
                        Name: "SubProgramID",
                        Type: "Select",
                        Required: true,
                        Options: []
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "Report Type:",
                        Name: "ReportType",
                        Type: "Select",
                        Required: true,
                        Options: [
                            {
                                text: "View Report Only",
                                value: "Download Only"
                            },
                            {
                                text: "Generate New Approval Email",
                                value: "Generate Approval Email"
                            },
                        ]
                    },
                ],

            };
        },
        methods: {

        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            AssignedTeamsOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramAssignedWraparoundTeamsOptions"]();
            },
        },
        components: {
            ReportDownloader
        },
        mounted() {
            let vm = this;
            this.ParamsSubProgramMonthYear[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramMonthYearIncludeFiles[0].Options = this.SubProgramOptions;
            this.ParamsCensusMetrics[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEnd[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramTargetDate[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEndProgramType[0].Options = this.SubProgramOptions;
            this.ParamsServiceList[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramTargetDateWeek[0].Options = this.SubProgramOptions;
            this.ParamsSupervisorTracker[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramMonthYear[0].Options = this.SubProgramOptions;
            this.ParamsSubProgramStartEndReportType[0].Options = this.SubProgramOptions;
            this.AssignedTeamsOptions.forEach(function (item) {
                 vm.ParamsSupervisorTracker[2].Options.push({
                     text: item.text,
                     nameSuffix: item.value,
                     checked: true
                 })
            });
            
            this.ParamsClientBirthdayOptions[0].Options = this.SubProgramOptions;
        }
    }
</script>

<style scoped>
</style>